import { ClientProxy } from '../../../base/proxy/clientProxy'
import { IRequesterInfo } from '../../../base/models'
import { IKaspersky, IKasperskyProducts, IKasperskyProductsRequest } from '../models/models'

export class PostKasperskyProductsApi extends ClientProxy {
  constructor(requesterInfo: IRequesterInfo) {
    super({
      url: 'product/GetFilteredKasperskyProducts',
      requesterInfo,
    })
  }

  public async getFilteredKasperskyProducts(request: IKasperskyProductsRequest): Promise<IKasperskyProducts[]> {
    return await this.postAsync<IKasperskyProducts[]>(request)
  }
}
